export default __webpack_public_path__ + "static/media/budget.c30313b9.png";